import { ValidationErrors } from '@angular/forms';
import { translate } from '@jsverse/transloco';

const errMessage: { [k: string]: (l: string, arg?: number) => string } = {
  email: (label: string) => translate('validation.invalid', { field: label }),
  required: (label: string) => translate('validation.required', { field: label }),
  minlength: (label: string, length?: number) => translate('validation.min_char', { field: label, count: length }),
  maxlength: (label: string, length?: number) => translate('validation.max_char', { field: label, count: length }),
  max: (label: string, max?: number) => translate('validation.max_val', { field: label, count: max }),
  min: (label: string, min?: number) => translate('validation.max_val', { field: label, count: min }),
  pattern: () => translate('validation.invalid_type', { field: translate('form.code'), type: translate('type.numeric') }),
};

const extraParamKey: { [k: string]: string } = {
  minlength: 'requiredLength',
  maxlength: 'requiredLength',
  max: 'max',
  min: 'min'
};

export function getFormErrorMessage(err: ValidationErrors | null, label?: string): string{
  if (!err) return '';

  const key = Object.keys(err)[0];
  return errMessage[key](label?? 'Data', err[key][extraParamKey[key]]);
}
